/**
 * board-variant-preference.js (GUI tarafı)
 * -----------------------------------------------------------------------
 * openblock-vm/src/io/web-compiler/board-variant-preference.js ile AYNI
 * localStorage anahtarını kullanır (aynı origin, GUI ve VM arasında
 * paylaşılıyor). Upload butonundaki Nano alt menüsü bunu yazıyor,
 * web-serialport.js flash sırasında okuyor.
 */

const STORAGE_KEY = 'ob_nano_bootloader_variant'; // 'new' | 'old'

export const getNanoBootloaderVariant = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || 'new';
    } catch (e) {
        return 'new';
    }
};

export const setNanoBootloaderVariant = variant => {
    try {
        window.localStorage.setItem(STORAGE_KEY, variant === 'old' ? 'old' : 'new');
    } catch (e) { /* localStorage kapalıysa sessizce geç */ }
};
